export const FETCHING_DATA_EVENT_KEY = "fetching-country-data";
export const DATA_RECEIVED_EVENT_KEY = "country-data-received";
export const SVG_NS = "http://www.w3.org/2000/svg";
